import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {EventService, LoginEvent} from '@spartacus/core';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {LAUNCH_CALLER, LaunchDialogService} from '@spartacus/storefront';
import {FeatureTogglesService} from '@dcp/configurator';
import {filter, first, startWith, switchMap} from 'rxjs';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {SAP_EMPLOYEE_WARNING_SHOWN_KEY} from './sap-employee-popup.constants';

const SAP_EMPLOYEE_IDP_PREFIXES = ['D', 'I', 'C'];

@UntilDestroy()
@Injectable({providedIn: 'root'})
export class SapEmployeePopupLoginListenerService {
  constructor(
    private eventService: EventService,
    private userFacade: UserAccountFacade,
    private launchDialogService: LaunchDialogService,
    private router: Router,
    private featureTogglesService: FeatureTogglesService,
  ) {
    this.initialize();
  }

  initialize(): void {
    this.eventService
      .get(LoginEvent)
      .pipe(
        switchMap(() => this.featureTogglesService.isEnabled(UNLEASH_TOGGLES.sapEmployeeWarningPopup)),
        filter(Boolean),
        filter(() => !sessionStorage.getItem(SAP_EMPLOYEE_WARNING_SHOWN_KEY)),
        switchMap(() => this.userFacade.get().pipe(first((user) => !!user))),
        filter((user) => SAP_EMPLOYEE_IDP_PREFIXES.some((prefix) => (user as any)?.idpIds?.startsWith(prefix))),
        switchMap(() => this.router.events.pipe(
          startWith(this.router.navigated ? new NavigationEnd(0, '', '') : null),
          filter((e): e is NavigationEnd => e instanceof NavigationEnd),
          first(),
        )),
        untilDestroyed(this)
      )
      .subscribe(() => {
        this.launchDialogService.openDialogAndSubscribe(
          LAUNCH_CALLER['SAP_EMPLOYEE_WARNING'] || 'SAP_EMPLOYEE_WARNING'
        );
      });
  }
}
